import { IconButton, IconButtonProps, styled } from '@mui/material';

const SquareIconButton = styled(
  ({ children, ...otherProps }: IconButtonProps) => (
    <IconButton disableRipple {...otherProps}>
      {children}
    </IconButton>
  )
)(({ theme }) => ({
  padding: theme.spacing(0.4),
  borderRadius: 0,

  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },

  '&:active': {
    backgroundColor: theme.palette.action.selected,
  },

  '&:focus-visible': {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: 2,
  },
}));

export default SquareIconButton;
